;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.RegistrationStep1 = View.RegistrationStep1.extend({
		template:   JST.ClubsIonataRegistrationStep1,
		initialize: function () {
			this.errors                  = false;
			this.backend_form_validation = [];
			this.view_data               = this.getOption('viewData');
			this.form_template           = this.getOption('formTemplate');
			this.steps_chain             = this.view_data.steps_chain;
			this.countries               = this.view_data.countries;
			this.states                  = this.view_data.states;
			this.squads                  = this.view_data.squads;
			this.fbconnect               = this.view_data.facebookModel;
			this.model                   = this.view_data.model;
			this.user                    = this.view_data.user;
			this.be_check                = this.view_data.first_step_BE_check;
			this.stepButtons             = this.view_data.first_step_buttons;
			this.dataLoaded              = false;

			var fields      = this.view_data.first_step_fields,
				head_fields = this.view_data.first_step_head_fields;

			fields      = fields.split(',');
			head_fields = head_fields.split(',');

			this.fields      = fields;
			this.head_fields = head_fields;

			fields = _.map(fields, function (field) {
				return field + ':change ' + field + ':blur';
			});

			head_fields = _.map(head_fields, function (field) {
				return field + ':change ' + field + ':blur';
			});

			this.getJSONData()
				.showPreloader();

			this.form = new Backbone.Form({
				template:     JST.ClubsIonataRegistrationStep1,
				model:        this.model,
				templateData: {
					first_step_fields:      this.fields,
					first_step_buttons:     this.stepButtons,
					first_step_head_fields: this.head_fields

				}
			});


			this.initListeners(fields)
				.customInitAdder(head_fields);

			this.listenTo(this.form, fields.join(' '), this.changeAndBlur);
			this.listenTo(this.form, 'country:change', this.changeCountry);
			this.listenTo(this.user, 'backend:user:validation', function (resp) {
				this.backend_form_validation.push(resp);
			});

			$.when.apply(null, this.complete).done(_.bind(function () {

				this.form.data = {
					countryList: this.countries.toJSON(),
					statesList:  this.states.toJSON(),
					squads:      this.squads.toJSON()
				};

				this.dataLoaded = true;

				this.anchorToTop()
					.hidePreloader();

				this.render();

			}, this));

			return this.render();
		},

		customInitAdder: function(head_fields){
			this.listenTo(this.form, head_fields.join(' '), this.changeAndBlur);
			return this;
		},

		onBackendCheckResponse: function (ckeckers) {

			$.when.apply(null, ckeckers)
				.done(_.bind(function () {

					if (!this.backend_form_validation.length) {
						var

							pick_data           = _.pick(this.form.getValue(), [this.head_fields, this.fields]),
							join_model_and_form = _.extend(this.model.toJSON(), pick_data),
							model               = {
								form: this.model.set(join_model_and_form),
								fb:   this.fbconnect
							};
						this.chooseNextStep(model);
					}
					else {

						this.showBackendErrors();

					}
				}, this));

			return this;
		},

		checkBeforeNextStep: function(event){
			event.stopPropagation();
			this.showPreloader();
			this.errors = false;

			var err = this.form.validate();

			_.find(this.head_fields, _.bind(function(value){
				if(_.has(err, value)){
					this.scrollToFieldError(value);
					return this.errors = true;
				}
			},this));

			_.find(this.fields, _.bind(function(value){
				if(_.has(err, value)){
					this.scrollToFieldError(value);
					return this.errors = true;
				}
			},this));

			if (!this.errors)  {
				/*BACKEND VALIDATIONS*/
				this.backend_form_validation = [];
				var be_checkers = _.map(this.be_check, this.generateBEMethodsArr, this);

				this.onBackendCheckResponse(be_checkers).hidePreloader();

			}
			else {
				this.hidePreloader();
			}
		},
	});


}(window, APP, Backbone, Marionette, $, _));